/**
 * 具体看 /ExtraBindService/data.config.js中定义的serviceType，在购物车Item中将会被使用
 */
export enum ExtraServiceType {
  /** care */
  CARE = 'care',
  /** 延保 */
  EXTEND = 'extend',
  /** care plus */
  CARE_PLUS = 'care_plus',
}
